import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Is your antivirus software genuine and fully licensed?",
    a: "Yes — 100% genuine, fully-licensed software. We have been an authorized reseller of AntivirusSales.com, LLC since 2019 (you can view our reseller certificate on the site). We also install and activate it on your devices for you.",
  },
  {
    q: "How long does delivery or setup take?",
    a: "It depends on the service: antivirus is usually set up the same day, radio setup takes about 1–3 days, a software consultation is scheduled within the same week, and full development projects are delivered on an agreed project timeline.",
  },
  {
    q: "What is your refund policy?",
    a: "You can request a refund within 7 days if the service hasn't been started or delivered yet. Every service also includes a 15-day free-fix guarantee — if something isn't working after delivery, we fix it free. See our Refund Policy page for full details.",
  },
  {
    q: "Do you charge any subscription or recurring fee?",
    a: "No. Every charge is a one-time payment for the service you select. We never auto-renew or bill you again unless you place a new order.",
  },
  {
    q: "Which payment methods do you accept?",
    a: "We accept secure payments via Razorpay and PayPal (including debit and credit cards). We do not store your full card details on our servers.",
  },
  {
    q: "Are you affiliated with any brand?",
    a: "No. Radio App Consultancy is an independent provider and authorized reseller. We are not affiliated with, endorsed by, or sponsored by any brand, and all product names, logos and trademarks are the property of their respective owners.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-[#F5F7FC] border-b border-[#E2E8F0]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6]">Good to know</p>
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight uppercase mt-3 text-[#0F172A]">Frequently asked questions</h2>
          <p className="text-[#475569] mt-4">Everything about pricing, delivery, refunds and genuine licenses.</p>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="rounded-2xl bg-white border border-[#E2E8F0] overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-[#F5F7FC] transition-colors"
                  data-testid={`faq-question-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-[#0F172A]">{f.q}</span>
                  <ChevronDown className={`h-5 w-5 text-[#3B82F6] shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.28 }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-5 text-sm text-[#475569] leading-relaxed" data-testid={`faq-answer-${i}`}>{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
